import { render, staticRenderFns } from "./TaxWarrantsCriteria.vue?vue&type=template&id=9703bbc4&scoped=true&"
import script from "./TaxWarrantsCriteria.vue?vue&type=script&lang=js&"
export * from "./TaxWarrantsCriteria.vue?vue&type=script&lang=js&"
import style0 from "./TaxWarrantsCriteria.vue?vue&type=style&index=0&id=9703bbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9703bbc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VRow,VTextField})
